import { Component, AfterViewInit, ViewChild, ElementRef, DoCheck } from '@angular/core';
import { GridOptions } from 'ag-grid';
import * as encoding from 'encoding-japanese';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { OwnerCarrierService } from '../../../service/owner-carrier/owner-carrier.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { Observable } from 'rxjs/Rx';

@Component({
  selector: 'app-wa9231',
  templateUrl: './wa9231.component.html',
  styleUrls: ['./wa9231.component.scss']
})
export class Wa9231Component implements AfterViewInit, DoCheck {
  private gridApi: any;
  public componentTitle = 'WA9231:荷主別配送会社マスタ照会';
  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];
  public ownerId: number;
  public ownerResult: any;
  public config = config;
  public working = false;
  public working2 = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';
  @ViewChild('gridView')
  private gridView: ElementRef;
  private gridHelper: AgGridHelper;
  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;
  private isShowSearchBlock = true;
  private isEnableClearFilter = null;
  private selectedCount = 0;
  private isShowSendLoading = false;

  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;
  private del: boolean = false;
  public wa9233Data: object;
  public selectedownerId;
  private isRefreshAndCheckNewData = false;
  private isOwnerSearchNone = false;

  constructor(private ownerCarrierService: OwnerCarrierService, private commonService: CommonService) {
    this.gridHelper = new AgGridHelper();
    this.gridHelper.gridSelectionCheckboxStyle = 'radio';
    this.gridOptions = <GridOptions>{
      rowSelection: 'single',
      floatingFilter: true,
      pagination: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      paginationPageSize: this.rowsPerPage,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa9231_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
        this.gridHelper.renderGridCheckboxImage();
        this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
        this.selectedCount = 0;
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        cellClass: ['tc', 'cl_w', 'noCellFocus'],
        headerCheckboxSelection: false,
        suppressMenu: true,
        pinned: 'left',
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        sort: 'asc',
        width: this.getColumnWidth('ownerCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '配送会社コード',
        field: 'carrierCd',
        width: this.getColumnWidth('carrierCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '配送会社名',
        field: 'carrierTx',
        width: this.getColumnWidth('carrierTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '配送伝票印刷区分',
        field: 'typeprintdeliTx',
        width: this.getColumnWidth('typeprintdeliTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      }
    ];
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonDubleMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.gridHelper.setGridOptions(this.gridOptions);
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa9231_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa9231_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa9231_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonDubleMargin;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    setTimeout(() => {
      this.onSubmit();
    }, config.waitMsForSearchInNgAfterViewInit);
  }

  changeOwner(selectedOwnerId) {
    this.selectedownerId = selectedOwnerId;
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit();
    } else {
      this.rowData = [];

      this.gridOptions.api.deselectAll();
    }
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working2) return;
    this.working2 = true;
    this.gridOptions.api.showLoadingOverlay();
    this.isRefreshAndCheckNewData = false;
    if (sessionStorage.getItem('isNotifyRefresh9231') != null) {
      sessionStorage.removeItem('isNotifyRefresh9231');
      this.isRefreshAndCheckNewData = true;
    }
    this.onFilterClear();
    this.ownerCarrierService
      .get(this.ownerId)
      .then(outputJson => {
        this.rowData = outputJson.ownercarriers;

        if (this.isRefreshAndCheckNewData == true && this.rowData != null && this.rowData.length > 0) {
          var latestDateStr = null;
          this.rowData.forEach((v, k) => {
            if (latestDateStr == null) {
              latestDateStr = v['addDt'];
            } else {
              var latestDate = new Date(Date.parse(latestDateStr.replace(/-/g, '/')));
              var curDate = new Date(Date.parse(v['addDt'].replace(/-/g, '/')));
              if (curDate.getTime() > latestDate.getTime()) {
                latestDateStr = v['addDt'];
              }
            }
          });
          setTimeout(() => {
            this.gridOptions.api.forEachNode(node => {
              if (node.data['addDt'] === latestDateStr) this.gridHelper.prepareSelectedAnimateByNodes([node]);
            });
            this.gridHelper.selectedAnimateDelay();
          }, 100);
        }
        this.isRefreshAndCheckNewData = false;
        setTimeout(() => {
          this.gridOptions.api.hideOverlay();
          this.working2 = false;
        },300);
      })
      .catch(error => {
        this.isRefreshAndCheckNewData = false;
        this.working2 = false;
        this.gridOptions.api.hideOverlay();
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.gridHelper.prepareSelectedAnimateByNodes(this.gridOptions.api.getSelectedNodes());
    if (sessionStorage.getItem('wa9233upd') === 'ok') {
      Observable.timer(100).subscribe(() => {
        this.gridHelper.selectedAnimate();
      });
      sessionStorage.removeItem('wa9233upd');
    }
  }

  insert() {
    sessionStorage.setItem('wa9232openotherwindow', 'open');
    sessionStorage.setItem('isWa9232FirstOpen', 'true');
    sessionStorage.removeItem('isShowOwnerSelect');
  }

  update() {
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    }
    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    this.wa9233Data = this.rowData[selectedIndex];
    sessionStorage.setItem('wa9233openotherwindow', 'open');
  }

  delete() {
    this.isShowSendLoading = true;
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      this.isShowSendLoading = false;
      return;
    }
    //SW-2097　ダブルクリック抑止
    if (this.working2) return;
    this.working2 = true;
    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    const selectedOwnerId = this.rowData[selectedIndex]['ownerId'];
    const selectedCarrierCd = this.rowData[selectedIndex]['carrierCd'];

    this.ownerCarrierService
      .delete(selectedOwnerId, selectedCarrierCd)
      .then(outputJson => {
        this.del = false;
        this.isShowSendLoading = false;
        this.working2 = false;
        this.onSubmit();
        //sessionStorage.setItem('SuccessInfoMessage', '完了,削除が完了しました');
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.isShowSendLoading = false;
        this.del = false;
        this.working2 = false;
      });
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  ngDoCheck() {
    if (this.selectedCount > 0) {
      this.working = true;
    } else {
      this.working = false;
    }
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }

  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9231/wa9231.component.ts